/**
 * Owner: Masa Bayu
 * File: hit-test-engine.ts
 * Date:Time: 2026-10-05 15:04
 * Description: Fasa 24 GREEN · bbox + segment traversal hit-test (pure math).
 */
const MISS = {
    isHit: false,
    atomId: null,
    wordIndex: null,
};
/**
 * Map pointer (mouseX, mouseY) → atom / word.
 * Prefer atom.wordWidths (interleaved word/space). Else linear estimate.
 */
export function hitTestAtom(atom, mouseX, mouseY) {
    if (mouseX < atom.bbox.x ||
        mouseX > atom.bbox.x + atom.bbox.width ||
        mouseY < atom.bbox.y ||
        mouseY > atom.bbox.y + atom.bbox.height) {
        return { ...MISS };
    }
    const relativeX = mouseX - atom.bbox.x;
    const words = atom.textContent.split(' ');
    const widths = atom.wordWidths && atom.wordWidths.length > 0 ? atom.wordWidths : null;
    const unit = atom.bbox.width / Math.max(atom.textContent.length, 1);
    let currentX = 0;
    let hitWordIndex = 0;
    for (let i = 0; i < words.length; i++) {
        const word = words[i] ?? '';
        const wordW = widths ? (widths[i * 2] ?? 0) : unit * word.length;
        const spaceW = i < words.length - 1 ? (widths ? (widths[i * 2 + 1] ?? 0) : unit) : 0;
        const segmentEndX = currentX + wordW + spaceW;
        if (relativeX <= segmentEndX) {
            hitWordIndex = i;
            break;
        }
        currentX = segmentEndX;
        hitWordIndex = i;
    }
    return {
        isHit: true,
        atomId: atom.id,
        wordIndex: hitWordIndex,
    };
}
//# sourceMappingURL=hit-test-engine.js.map